import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { WorkDistributionSummaryReport } from './Pages/listing';

export const WorkDistributionSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={WorkDistributionSummaryReport} />
    </Fragment>
)